/* Solyvio winkelwagen: cadeau, Kaching-upgrade, carrousel, teller. Werkt bovenop Impulse CartDrawer. */
(function () {
  if (window.__svCart) return;
  window.__svCart = true;

  var busy = false;
  var GIFT_NO = 'svGiftDeclined';
  var TIER_KEY = 'svTiers:';

  function money(c) {
    try { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }
    catch (e) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function rebuild() { document.dispatchEvent(new CustomEvent('cart:build')); }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-SV-Cart': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function changed(cart) {
    rebuild();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  /* ---------- Kaching-bundels per product ---------- */
  var tierCache = {};
  function getTiers(handle) {
    if (tierCache[handle]) return tierCache[handle];
    var cached = ss(TIER_KEY + handle);
    if (cached) { try { return (tierCache[handle] = Promise.resolve(JSON.parse(cached))); } catch (e) {} }
    tierCache[handle] = fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var bars = [];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('script.kaching-bundles-deal-block-settings');
          if (el) {
            try {
              var d = JSON.parse(el.textContent);
              (d.dealBars || []).forEach(function (b) {
                var q = parseInt(b.quantity, 10);
                if (q > 0) bars.push({ q: q, type: b.discountType, v: parseFloat(b.discountValue) || 0, title: (b.title || '').trim() });
              });
            } catch (e) {}
          }
        }
        bars.sort(function (a, b) { return a.q - b.q; });
        ss(TIER_KEY + handle, JSON.stringify(bars));
        return bars;
      })
      .catch(function () { return []; });
    return tierCache[handle];
  }
  function tierTotal(bar, unit) {
    if (bar.type === 'specific') return Math.round(bar.v * 100);
    if (bar.type === 'percentage') return Math.round(unit * bar.q * (1 - bar.v / 100));
    if (bar.type === 'fixed' || bar.type === 'amount') return Math.round((unit - bar.v * 100) * bar.q);
    return null;
  }
  function renderUpgrade(box) {
    var qty = parseInt(box.dataset.qty, 10);
    var unit = parseInt(box.dataset.unit, 10);
    var line = parseInt(box.dataset.line, 10);
    getTiers(box.dataset.handle).then(function (bars) {
      var next = null;
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].q > qty && tierTotal(bars[i], unit) !== null) { next = bars[i]; break; }
      }
      if (!next || !box.isConnected) return;
      var total = tierTotal(next, unit);
      var diff = total - line;
      var per = Math.round(total / next.q);
      var code = (next.title || '').match(/^\s*\d+\s*\+\s*\d+/);
      var label = code ? code[0].replace(/\s+/g, '') : (next.q + ' stuks');
      var sub = diff > 0
        ? next.q + ' stuks voor ' + money(total) + ' (+' + money(diff) + ') · ' + money(per) + ' per stuk'
        : next.q + ' stuks voor ' + money(total) + (diff < 0 ? ' · je betaalt ' + money(-diff) + ' minder' : ' · zonder meerprijs');
      box.innerHTML =
        '<div class="sv-up__txt"><strong>Maak er ' + label.replace(/</g, '&lt;') + ' van</strong><span>' + sub + '</span></div>' +
        '<button type="button" class="sv-up__btn" data-sv-upgrade="' + next.q + '">Upgrade</button>';
      box.hidden = false;
    });
  }

  /* ---------- Cadeau vanaf drempel ---------- */
  function syncGift(items) {
    var act = items.dataset.svGift;
    if (!act || busy) return;
    if (act === 'add') {
      if (ss(GIFT_NO) === '1') return;
      busy = true;
      post('/cart/add.js', { items: [{ id: parseInt(items.dataset.svGiftVariant, 10), quantity: 1, properties: { _sv_gift: '1' } }] })
        .then(function () { busy = false; rebuild(); })
        .catch(function () { busy = false; });
    } else if (act === 'remove' || act === 'one') {
      busy = true;
      post('/cart/change.js', { id: items.dataset.svGiftKey, quantity: act === 'one' ? 1 : 0 })
        .then(function (cart) { busy = false; changed(cart); })
        .catch(function () { busy = false; });
    }
  }

  /* ---------- Na elke herbouw ---------- */
  function enhance() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var items = drawer.querySelector('.cart__items');
    if (!items) return;
    var count = parseInt(items.dataset.count, 10) || 0;
    var sub = parseInt(items.dataset.cartSubtotal, 10) || 0;
    var c = drawer.querySelector('[data-sv-count]');
    if (c) c.textContent = '· ' + count + (count === 1 ? ' item' : ' items');
    var p = drawer.querySelector('[data-sv-checkout-price]');
    if (p) p.textContent = money(sub);
    items.querySelectorAll('.sv-up').forEach(renderUpgrade);
    syncGift(items);
  }

  function watch() {
    var target = document.querySelector('#CartDrawer [data-products]');
    if (!target) return false;
    new MutationObserver(function () { enhance(); }).observe(target, { childList: true });
    enhance();
    return true;
  }
  if (!watch()) document.addEventListener('DOMContentLoaded', watch);

  /* ---------- Lege winkelwagen: willekeurige 8 producten ---------- */
  function shuffleEmpty() {
    var track = document.querySelector('#CartDrawer [data-sv-random]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-sv-rand]'));
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
    }
    cards.forEach(function (c, i) { c.style.display = i < 8 ? '' : 'none'; track.appendChild(c); });
    track.scrollLeft = 0;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shuffleEmpty); else shuffleEmpty();
  document.addEventListener('cart:open', shuffleEmpty);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-drawer-open-cart')) setTimeout(shuffleEmpty, 0);
  });

  /* ---------- Klikken ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var giftRm = t.closest && t.closest('[data-sv-gift-remove]');
    if (giftRm) ss(GIFT_NO, '1');

    var up = t.closest && t.closest('[data-sv-upgrade]');
    if (up) {
      e.preventDefault();
      var box = up.closest('.sv-up');
      up.disabled = true;
      up.classList.add('is-loading');
      post('/cart/change.js', { id: box.dataset.key, quantity: parseInt(up.dataset.svUpgrade, 10) })
        .then(changed)
        .catch(function () { up.disabled = false; up.classList.remove('is-loading'); });
      return;
    }

    var arrow = t.closest && t.closest('[data-sv-scroll]');
    if (arrow) {
      e.preventDefault();
      var track = arrow.closest('.sv-ups').querySelector('.sv-ups__track');
      var card = track.querySelector('.sv-card');
      var step = card ? card.getBoundingClientRect().width + 10 : 180;
      track.scrollBy({ left: step * parseInt(arrow.dataset.svScroll, 10), behavior: 'smooth' });
    }
  }, true);

  /* ---------- Andere apps (bijv. Kaching) die via /cart/add toevoegen: drawer verversen + openen ---------- */
  var lastOpen = 0;
  function afterExternalAdd() {
    if (Date.now() - lastOpen < 800) return;
    lastOpen = Date.now();
    rebuild();
    document.dispatchEvent(new CustomEvent('cart:open'));
  }
  document.addEventListener('ajaxProduct:added', function () { lastOpen = Date.now(); });

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = false;
    try {
      var h = (init && init.headers) || {};
      own = !!(h['X-SV-Cart'] || (h.get && h.get('X-SV-Cart')));
    } catch (e) {}
    var res = _fetch.apply(this, arguments);
    if (!own && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      res.then(function (r) { if (r.ok) setTimeout(afterExternalAdd, 150); }).catch(function () {});
    }
    return res;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.__svAdd = /\/cart\/add(\.js)?(\?|$)/.test(url || '');
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__svAdd) {
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(afterExternalAdd, 150); });
    }
    return _send.apply(this, arguments);
  };
})();
